<template>

  <v-app-bar color="light" dark app clipped-left>
    <v-app-bar-nav-icon color="#1897fe" @click="drawer=!drawer"></v-app-bar-nav-icon>
    <v-app-bar-title>{{ header_title }} </v-app-bar-title>
    
    <div class="appnav" style="padding: 0 15px;">
      <div><i class="mdi mdi-home me-1" style="font-size: 1.5rem;"></i></div>
      <div>{{ "道場コード:" }}</div>
      <div>{{ group_code }}</div>

      <div><i class="mdi mdi-account-circle me-1" style="font-size: 1.5rem;"></i></div>
      <div>{{ user_name }}</div>
    </div>
  </v-app-bar>

  <!-- 色付きドロワー -->
  <v-navigation-drawer
    app
    v-model="drawer"
    clipped
    :class="['sidenav', sideClass]"
  >
    <v-list>
      <template v-for="(item,index) in items" :key="item.title">
        <v-list-item
          v-if="this.authority_id >= item.role"
          :href="item.to"
          link
        >
          <div :style="{'color': get_selected_color(sub_title,item)}" class="menu">
            <v-icon>{{ item.icon }}</v-icon>{{ item.title }}
          </div>
        </v-list-item>
      </template>
    </v-list>
    <template v-slot:append>
      <!-- <div class="pa-2">
        <v-btn block @click="new_dialog = true">
          パスワード変更
        </v-btn>
        <v-dialog
                v-model="new_dialog"
                width="auto"
                persistent
            >
                <v-card 
                    width="500"
                >
                    <template v-slot:title>
                        <div class="d-flex justify-space-between">
                            <h4>パスワード変更</h4>
                            <div>
                                <v-icon @click="cancel()" style="font-size: 2rem;">
                                    mdi mdi-close-circle
                                </v-icon>
                            </div>
                        </div>
                    </template>
                    <template v-slot:text>
                        <form id="new_form" name="new_form">
                            <div class="sub_window_content">    
                                <div class="mb-3">
                                    <div>
                                        パスワード
                                    </div>
                                    <div class="textlines">
                                        <input type="password" class="form-control" name="password" v-model="form_password">
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div>
                                        パスワード(確認)
                                    </div>
                                    <div class="textlines">
                                        <input type="password" class="form-control" name="password_confirm" v-model="form_password_confirm">
                                        <div v-if="new_password_error">
                                            <span style="color: red;">{{new_password_error }}</span>
                                        </div>
                                    </div>
                                </div>                                    
                            </div>
                        </form>
                    </template>
                    <v-card-actions>
                            <v-btn
                                class="btn btn-cancel"
                                text="キャンセル"
                                @click="cancel()"
                            ></v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                class="btn btn-new"
                                text="登録"
                                @click="form_new()"
                            ></v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>
      </div> -->
      <v-container class="pa-2">
        <v-card
            class="plan-card"
            elevation="2"
        >
            <v-card-text class="pa-2">
                <div class="plan-row disp">
                    <span class="plan-title"><i class="mdi mdi-home me-1" ></i></span>
                    <span class="label"> {{ "道場コード:" }}</span>
                    <span class="value">{{ group_code }}</span>
                </div>
                <div class="plan-row disp">
                    <span class="plan-title"><i class="mdi mdi-account-circle me-1" ></i></span>
                    <span class="value">{{ user_name }}</span>
                </div>
                <div class="plan-row">
                    <span class="plan-title">{{ plan_info.plan_name }}</span>
                    <span class="label">  （追加枠 </span>
                    <span class="value">{{ plan_info.additional_unlocks }}</span>
                    <span class="value">人）</span>
                </div>
                <div class="plan-row">
                    <span class="label">制限解除：</span>
                    <span class="value">{{ plan_info.unlock_user_sum }}</span>
                    <span class="value">人</span>
                </div>
                <div class="plan-row">
                    <span class="label">残り枠　：</span>
                    <span class="value">{{  plan_info.unlock_remaining }}</span>
                    <span class="value">人</span>
                </div>
            </v-card-text>
        </v-card>
      </v-container>

      <div class="pa-2">
        <v-btn block v-on:click="logout">Logout</v-btn>
        <form id="logout-form" :action="logout_url" method="POST" style="display: none;">
        <input type="hidden" name="_token" :value=csrf_token>
        </form>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<style scoped>
  .appnav{
    display: flex;
    align-items: center;
    @media(max-width: 500px) {
        display: none;
    }
  }
  .disp{
    display: none;
    @media(max-width: 500px) {
        display: flex;
    }
  }
  .sidenav .menu{
    font-size: 1.1rem;
    padding: 10px 0;
  }
  .sidenav .menu i{
    margin-right: 10px;
  }
  .sidenav-admin {
    background: #788dd1;
  }
  .sidenav-user {
    background: #80D96A;
  }
</style>
<script>
export default {
  name: "HeaderComponent",
  props: {
    header_title:String,
    sub_title:String,
    user_name:String,
    user_id:Number,
    match_list_url:String,
    notification_list_url:String,
    user_management_list_url:String,
    group_management_list_url:String,
    logout_url:String,
    password_change_url:String,
    authority_id:Number,
    help_url: String,
    payment_info_url: String,
    group_code: String,
    plan_info: {
        plan_name: Object,
        unlock_user_sum: Object,
        unlock_remaining: Object,
        additional_unlocks: Object,
    },
  },
  computed: {
    sideClass() {
      return this.authority_id == 1 ? 'sidenav-admin' : 'sidenav-user'
    }
  },
  components: {
    
  },
  data: function () {
      return {
        new_dialog: false,
        new_password_error: null,
        drawer: null,
        isActive: true,
        items: [
          { title: '道場管理', role: 1, icon: 'mdi-home', to: this.group_management_list_url , disp_id: '1'},
          { title: '試合一覧', role: 2, icon: 'mdi-karate', to: this.match_list_url , disp_id: '2'},
          { title: 'お知らせ一覧', role: 1, icon: 'mdi-clipboard-text', to: this.notification_list_url , disp_id: '3'},
          { title: 'ユーザー管理', role: 2, icon: 'mdi-account-settings', to: this.user_management_list_url , disp_id: '4'},
          { title: '支払い管理', role: 2, icon: 'mdi-credit-card', to: this.payment_info_url , disp_id: '6'},
          { title: 'ヘルプ', role: 1, icon: 'mdi-help', to: this.help_url , disp_id: '3'},
        ],
        csrf_token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        activeColor:'red',
      }
  },
  created: function () {
    
  },
  mounted: function(){
    
  },
  methods: {
      logout() {
        document.getElementById('logout-form').submit();
      },
      get_selected_color(sub,item){
        for(var i = 0; i < this.items.length; i++){
          if(sub == item.title){
            return '#666';
          }
          else{
            return '#fff'
          }
        }
      },
      form_new:function(){
          var self = this;
          var url = self.password_change_url;
          var url = self.password_change_url.replace(':id', this.user_id);
          var form = document.forms.new_form;
          var isval = true;
          isval = self.isValidation();

          if(!isval){
              return;
          }
          var params = new URLSearchParams(new FormData(form));

          axios.post(url, params).then(function(res) {
              if (res.data.result == 'ok') {
                  self.form_password = null;
                  self.form_password_confirm = null;
                  self.new_dialog = false;
              } 
              else {
                  self.alertErrorMessage(res.data);
              }
          })
          .catch(function(err) {
              if (error.response) {
                  self.alertErrorMessage(error.response.data);
              }
          });
      },
      cancel:function(){
          this.form_password = null;
          this.form_password_confirm = null;
          this.new_password_error = "";
          this.new_dialog = false;
      },
      /* エラーメッセージをアラートで表示  
      * なければ'予期せぬエラーが発生しました'と表示
      */
      alertErrorMessage:function(res_date){
          if(res_date.message){
              alert(res_date.message);
          }
          else{
              alert('予期せぬエラーが発生しました');
          }
      },
      isValidation:function(){
          this.new_password_error = "";
          var count = 0;

          if(this.form_password == "" || this.form_password== null){
              this.new_password_error = "必須項目です";
              count++;
          }
          else if(this.form_password != this.form_password_confirm){
              this.new_password_error = "パスワードが相違しています";
              count++;
          }

          if(count != 0){
              return false;
          }
          return true;

      }, 
  },
};
</script>
